<template>

  <div class="row">
	 
    <div class="col-md-12">
      <h4 class="title">Companies</h4>
      <p class="category">
      List of companies under your charge.
      </p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Extended</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select style="display:none;"
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search"
                      v-model="searchQuery"
                       v-on:change="searchingCompanies"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        
       <div style="margin-right:50px;">
		  <fg-input >
                  <el-select class="select-primary"
                             size="large"
                             @change="onNumEntriesChange($event)"
                             placeholder="Display"
                             v-model="numEntries"

                             >
                    <el-option v-for="option in selects.numEntriesOptions"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>

    </div>
    
    
     <div style="margin-right:50px;">
		  <fg-input >
                  <el-select class="select-primary"
                             size="large"
                             @change="onViewCompanyStatusChange($event)"
                             placeholder="Select Company Status"
                             v-model="viewCompanyStatus"

                             >
                    <el-option v-for="option in selects.viewCompanyStatus"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>

    </div>
    
    <div style="">
		  <fg-input >
                  <el-select class="select-primary"
                             size="large"
                             @change="onSortTypeChange($event)"
                             placeholder="Sort By"
                             v-model="sortType"

                             >
                    <el-option v-for="option in selects.sortType"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>

    </div>
    
  
    
    
    
        <div id="cs_companies_pg" class="col-sm-12 mt-2">
          <el-table class="table-striped"
          		
                    :data="tableData"
                    border
                    style="width: 100%;cursor:pointer" @row-click="viewEntity"
                    :row-class-name="entityRowClassName"
                    >
            <el-table-column label="Entity Name" property="entity_name" width="250" ></el-table-column>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             style="font-size:13px;!important"
                             >
            </el-table-column>

             <el-table-column label="Days To AGM Deadline" property="days_to_agm_deadline" width="105">
            		<template slot-scope="scope">
           				 <span v-if="scope.row.days_to_agm_deadline==='-'"><i style="color:green;font-size:24px;" class="nc-icon nc-check-2"></i></span>
           				 <span v-else-if="scope.row.days_to_agm_deadline<0" style="color:red;">{{scope.row.days_to_agm_deadline}}</span>
           				 <span v-else style="font-weight:bold;font-size:14px;">{{scope.row.days_to_agm_deadline}}</span>
    
          			</template>
            
            </el-table-column>
            
          <!--  <el-table-column label="AGM Status" property="agm_status" width="105">
            	<template slot-scope="scope">
            		 <span v-if="scope.row.agm_status==='Exempted'"><i style="color:green;">{{scope.row.agm_status}}</i></span>
            		<span v-else>{{scope.row.agm_status}}</span>
            	</template>
            </el-table-column>-->
            
            
             <el-table-column label="AGM Status" property="agm_status" width="105">
            	<template slot-scope="scope">
            		 <span v-if="scope.row.agm_status==='Exempted'"><i style="color:green;">{{scope.row.agm_status}}</i></span>
            		<span v-else>
						<span v-if="scope.row.agm_filing==2">Not Done</span>
      				    <span v-if="scope.row.agm_filing==1">Done</span>
            		
            		</span>
            	</template>
            </el-table-column>
            
            
            <!--
            <el-table-column label="Days To AR Deadline" property="days_to_ar_deadline" width="105">
            		<template slot-scope="scope">
           				 <span v-if="scope.row.days_to_ar_deadline==='-'"><i style="color:green;font-size:24px;" class="nc-icon nc-check-2"></i></span>
           				 <span v-else-if="scope.row.days_to_ar_deadline<=10" style="color:red;font-weight:bold;">{{scope.row.days_to_ar_deadline}}</span>

           				  <span v-else-if="scope.row.days_to_ar_deadline==='Pending AGM'"><i style="color:red;font-size:24px;" class="nc-icon nc-simple-remove"></i></span>
           				 <span v-else style="font-weight:bold;font-size:14px;">{{scope.row.days_to_ar_deadline}}</span>
    
          			</template>
            
            </el-table-column>
            -->
            
            <el-table-column label="AR Status"  width="105">
            
            	<template slot-scope="scope">
            		
						<span v-if="scope.row.ar_filing==2">Not Done</span>
      				    <span v-if="scope.row.ar_filing==1">Done</span>
            		
            	</template>
            </el-table-column>
            
            
            <el-table-column label="FS Filing"  width="105">
            		<template slot-scope="scope">
           				 <span v-if="scope.row.f_filing=='not_due'">Not Due</span>
           				 <span v-if="scope.row.f_filing=='due'">Due</span>
           				 <span v-if="scope.row.f_filing=='filed'">Filed</span>

           		
          			</template>
            
            </el-table-column>
            
            
            
            
            <!--<el-table-column
              :min-width="50"
              fixed="right"
              class-name="td-actions"
              label="" >
              <template slot-scope="props">
                <p-button type="warning" size="sm" icon @click="handleTask(props.$index, props.row)">
                  <i class="fa fa-briefcase"></i>
                </p-button>

              </template>
            </el-table-column>-->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{pagination.total}} entries</p>
        </div>
        <div class="col-sm-6">
           <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    
    
     <div style="text-align:right;width:100%">
 	 <p-button type="info" @click="goToCreateEntity()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Add New Entity
      </p-button>
  </div>
  
  
  <div style="width:100%"><h4 style="font-weight:bold">Legend</h4></div>
  <card>
  <div style="padding:20px">
       <div style="padding:10px 30px 10px 30px;background-color:#f5c6cb;border-radius:5px;margin-bottom:10px;font-size:13px;">Overdue AGM/AR</div>
       <div style="padding:10px 30px 10px 30px;background-color:#ffeeba;border-radius:5px;margin-bottom:10px;font-size:13px;">Passed FYE Date. Pending AGM/AR</div>
        <div style="padding:10px 30px 10px 30px;background-color:#fff;border-radius:5px;margin-bottom:10px;border:1px solid #333;font-size:13px;">AR Filed</div>
       
  </div>
  </card>
  
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    computed: {
      pagedData () {
        //return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      /*queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },*/
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        //this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    
    data () {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        selects: {
          viewCompanyStatus: [
            {value: 1, label: 'Live Companies'},
            {value: 2, label: 'Dormant'},
            {value: 3, label: 'Struck-off'},
            {value: 4, label: 'Dropped'},
            {value: 5, label: 'Onboarding'},
		   ],
		   numEntriesOptions:[
            {value: 35, label: '35/page'},
            {value: 70, label: '70/page'},
            {value: 150, label: '150/page'},
			{value: 250, label: '250/page'},
		   ],
		   sortType:[
            {value: 1, label: 'Sort: Default'},
            {value: 2, label: 'Sort: Company Name'},

		   ],
		},
		viewCompanyStatus:1,
        searchQuery: '',
        loadedPage: 0,
        numEntries: 35,
        sortType: 1,
        propsToSearch: ['entity_name', 'uen'],
        tableColumns: [
         
          {
            prop: 'uen',
            label: 'UEN',
            minWidth: 85
          },
 
          {
            prop: 'registered_address',
            label: 'Registered Address',
            minWidth: 250
          },
          {
            prop: 'date_fye_str',
            label: 'FYE',
            minWidth: 90
          },

          
 


        ],
        tableData: []
      }
    },
     watch: {
     'pagination.currentPage': function ()  {
 
     		if(this.pagination.currentPage && this.loadedPage!=this.pagination.currentPage && this.loadedPage){
    			this.loadPage();
    		}
    	}
	},
    mounted() {
      	this.loadCompanies(1);
      
    },
    methods: {
       searchingCompanies(){
       		this.loadPage();
       },
       loadPage(){
    		  swal.showLoading();
			  let uri = this.$base_url+'/api/v1/entities/all/'+this.viewCompanyStatus+'?page='+this.pagination.currentPage+"&qq="+this.searchQuery+"&num="+this.numEntries+"&sort="+this.sortType;
			  ApiService.get(uri).then(response => {
				let companies = response.data.entities.data;
				this.pagination.total = response.data.entities.total;
			    this.pagination.currentPage = response.data.entities.current_page;
			    this.pagination.perPage = response.data.entities.per_page;
			    this.loadedPage = response.data.entities.current_page;
			    
			 
			 
		
				var entityStatusList = this.$entity_status;
				companies.forEach(function(e){
					for (var i = 0; i < entityStatusList.length; i++) {
						if(e.company_status == entityStatusList[i]["value"]){
							e.company_status = entityStatusList[i]["label"];
							break;
						}
					}
		
				});
		
				 this.tableData = companies;
				 swal.close();
       
       	 	 })
    	
    	},
       loadCompanies(status){
       		  swal.showLoading();
			  let uri = this.$base_url+'/api/v1/entities/all/'+status;
			  ApiService.get(uri).then(response => {
				let companies = response.data.entities.data;
				this.pagination.total = response.data.entities.total;
			    this.pagination.currentPage = response.data.entities.current_page;
			    this.pagination.perPage = response.data.entities.per_page;
			    this.loadedPage = response.data.entities.current_page;
			    
			 
			 
		
				var entityStatusList = this.$entity_status;
				companies.forEach(function(e){
					for (var i = 0; i < entityStatusList.length; i++) {
						if(e.company_status == entityStatusList[i]["value"]){
							e.company_status = entityStatusList[i]["label"];
							break;
						}
					}
		
				});
		
				 this.tableData = companies;
				 swal.close();
       
       	  })
       },
       onViewCompanyStatusChange(){
       		this.loadPage();
       },
       onSortTypeChange(){
       		this.loadPage();
       },
       onNumEntriesChange(){
   	    	this.loadPage();
       },
       
       filterCompanyStatus(value, row) {
        return row.company_status === value;
      },
      entityRowClassName({row}){
      		if(row.days_to_agm_deadline <= 0){
      			return "table-danger";
      		}
      		else if(row.days_to_ar_deadline <= 0){
      			return "table-danger";
      		}
      		else if(row.passed_fye ==1){
      			return "table-warning";
      		}
      },
      goToCreateEntity(){
      	 this.$router.push( '/create-entity/0')
      },
      handleTask (index, row) {
        let entity_id = this.tableData[index].id;
        
        this.$router.push( '/create-task/'+entity_id)
      },
      viewEntity (row) {
        let entity_id = row.id;
        
        this.$router.push( '/view-entity/'+entity_id)
      },
      handleEdit (index, row) {
      
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      }
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
  
  .el-table{
  	color:#000;
  }
  
  .el-table thead{
  	background-color:#000;
  	color:#fff;
  }
  
  .el-table .cell{
  	word-break:normal!important;
  }
  
  #cs_companies_pg  .el-table .cell{
  	font-size:13px!important;
  }
  
  .card label{
  	color:#000!important;
  	font-weight:bold;
  }
  
  .cs-strikethrough{
  	text-decoration:line-through;
  }
  
  .main-panel{
  	background-color:#eee!important;
  }
  
  .card{
  	border-radius:5px!important;
  }
  
  
  .sidebar[data-color="black"]::after, .off-canvas-sidebar[data-color="black"]::after{
  	background-color:#000!important;
  }
  
</style>
